import { Icon, InputAdornment, TextField } from "@material-ui/core";
import React, { useState } from "react";

export default ({ field, handleBlur, ...props }) => {
  const [state, setState] = useState(field.value || "");
  const handleChange = (e) => setState(e.target.value);

  let disabled = false;
  if (field.is_basic && field.name != "nome_credor") disabled = true;

  return (
    <TextField
      fieldid={field.id}
      disabled={disabled}
      inputProps={{
        maxLength: field.name == "ano_vencimento" ? 4 : null,
        fieldid: field.id,
      }}
      InputProps={{
        endAdornment: field.updating ? (
          <InputAdornment position="end" className="p-12">
            <Icon className="fas fa-sync fa-spin m-color-blue" />
          </InputAdornment>
        ) : field.icon ? (
          <InputAdornment position="end" className="p-12">
            <Icon className={field.icon} />
          </InputAdornment>
        ) : null,
      }}
      label={field.label}
      onChange={handleChange}
      variant="outlined"
      onBlur={handleBlur}
      value={state}
      {...props}
    />
  );
};
